<template>
  <el-dialog
    :visible.sync="purchaseChangesModalShow"
    width="30%"
    @closed="$emit('close')"
  >
    <div class="row" slot="title" style="border-bottom: 1px solid #dddddd">
      <div class="col-12">
        <h4 class="m-0 pt-1 text-navy">Purchase Changes Requested</h4>
        <div class="text-warning mb-2 fa-sm mt-1">
          Purchase update request pending for approval
        </div>
      </div>
    </div>
    <div class="row small-ui">
      <div
        class="col-12"
        v-for="pendingClientTransaction in pending_client_transactions"
        :key="pendingClientTransaction.id"
      >
        <p class="mt-0 pt-0">
          Changes requested:
          {{
            moment(pending_client_transactions.created_at).format("DD/MM/YYYY")
          }}
        </p>
        <div
          v-for="field in pendingClientTransaction.update_fields"
          :key="field.id"
          class="mb-2"
        >
          <div
            class="d-flex flex-row align-items-left"
            v-for="(value, property, index) in field.transform_property"
            :key="index"
          >
            <div>
              <div v-if="typeof value == 'object'">
                <p class="mb-0">
                  <strong>{{ getName(property) }}:</strong>
                </p>
                <div class="pl-4">
                  <div v-for="(v, p, i) in value" :key="i">
                    <div v-if="typeof v == 'object'">
                      <p class="mb-0" v-for="(vl, pl, il) in v" :key="il">
                        <strong>{{ getName(pl) }}:</strong>
                        {{ vl }}
                      </p>
                    </div>
                    <div v-else>
                      <strong>{{ getName(p) }}:</strong> {{ v }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="mb-0">
                  <strong>{{ getName(property) }}:</strong> {{ value }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="media in pendingClientTransaction.files"
          :key="media.id"
          class="mb-2"
        >
          <div class="row">
            <div class="col-12">
              <a
                :href="`/admin/medias/${media.id}`"
                class="text-blue"
                data-toggle="tooltip"
                data-placement="top"
                title="Download File"
                >{{ media.name }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import PurchasePropertyName from "../../../../constants/PurchasePropertyName.js";
export default {
  props: {
    initial_purchase: {
      type: Object,
    },
  },

  data() {
    return {
      purchaseChangesModalShow: true,
      pending_client_transactions: this.initial_purchase
        ? this.initial_purchase.pending_client_transactions
        : [],
      files: [],
    };
  },
  async created() {},

  methods: {
    getName(attribute) {
      let attributes = Object.keys(PurchasePropertyName).map((key) => {
        return PurchasePropertyName[key];
      });

      let result = attributes.find((x) => x.attribute == attribute);
      if (result) {
        return result.name;
      } else if (attribute) {
        return attribute;
      }

      return "";
    },
  },
};
</script>
